<template>
  <v-layout row justify-center align-center>
    <v-flex xs12>
      <v-card>
        <errors-list :errorMessage="error.errorMessage" />

        <v-form ref="form" @submit.prevent="onSubmit" v-model="formValid" color="green">
          <v-card-text>
            <v-layout row justify-center align-start>
              <v-flex xs6 class="px-1">
                <h5 class="text-uppercase pl-1 pb-2">{{ $t('@customer/personalInfo/title') }}</h5>

                <v-text-field
                  v-model="form.personalNumber"
                  color="green darken-1"
                  :label="$t('@customer/personalInfo/personalNumberLabel')"
                  disabled
                  :rules="[validateRequired]"
                />

                <v-text-field
                  v-model="form.firstName"
                  color="green darken-1"
                  maxlength="40"
                  :rules="[validateRequired]"
                  :label="$t('@customer/personalInfo/firstNameLabel')"
                />
                <v-text-field
                  v-model="form.middleName"
                  color="green darken-1"
                  maxlength="40"
                  :label="$t('@customer/personalInfo/middleNameLabel')"
                />
                <v-text-field
                  v-model="form.lastName"
                  color="green darken-1"
                  maxlength="40"
                  :rules="[validateRequired]"
                  :label="$t('@customer/personalInfo/lastNameLabel')"
                />
              </v-flex>

              <v-flex xs6 class="px-1">
                <h5 class="text-uppercase pl-1 pb-2">{{ $t('@customer/contacts/title') }}</h5>

                <v-text-field
                  v-model="form.mobilePhone"
                  mask="0## ### ## ##"
                  color="green darken-1"
                  :rules="[validateRequired]"
                  :label="$t('@customer/contacts/mobilePhoneLabel')"
                />
                <v-text-field
                  type="email"
                  maxlength="50"
                  v-model="form.email"
                  :rules="[validateEmail]"
                  color="green darken-1"
                  :label="$t('@customer/contacts/emailLabel')"
                />

                <v-text-field
                  v-model="form.city"
                  color="green darken-1"
                  maxlength="30"
                  :rules="[validateRequired]"
                  :label="$t('@customer/contacts/cityLabel')"
                />
                <v-text-field
                  v-model="form.address"
                  color="green darken-1"
                  maxlength="40"
                  :rules="[validateRequired]"
                  :label="$t('@customer/contacts/addressLabel')"
                />
                <v-text-field
                  v-model="form.zipCode"
                  color="green darken-1"
                  maxlength="6"
                  :rules="[validateRequired]"
                  :label="$t('@customer/contacts/zipLabel')"
                />
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-divider />
          <v-card-actions>
            <v-btn :disabled="submitting" color="red darken-1" flat @click="closeModal(false)">
              {{ $t('@debtForm/cancelButtonLabel') }}
            </v-btn>
            <v-spacer />

            <v-btn type="submit" :disabled="!isFormDirty || submitting" color="green darken-1" flat>
              {{ $t('@debtForm/submitButtonLabel') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationError, getErrorObject } from '../../errorHandlers';
import ErrorsList from '../../components/ErrorsList';
import { emailRegexp, emojiRegex, phonePrefixHardcode } from '../../utils';

export default {
  components: { ErrorsList },
  props: {
    customer: {
      type: Object,
    },
  },

  data() {
    return {
      submitting: false,
      error: {
        errorMessage: '',
        errorField: '',
      },
      success: true,
      isFormDirty: false,
      formValid: true,
      form: {
        id: 0,
        mobilePhone: '',
        personalNumber: '',
        firstName: '',
        lastName: '',
        middleName: '',
        city: '',
        address: '',
        zipCode: '',
      },
      validationError,
    };
  },

  watch: {
    form: {
      handler: function(newVal, oldVal) {
        // form changed after it was populated from props
        this.isFormDirty = !!oldVal.id;
      },
      deep: true,
    },
  },

  computed: {
    sanitizedForm() {
      return Object.entries(this.form).reduce(
        (a, [k, v]) => ({ ...a, [k]: String(v) === v ? v.replace(emojiRegex, '') : v }),
        {},
      );
    },
  },

  methods: {
    closeModal(isSent = false) {
      this.$emit('close-modal', isSent);
    },

    validateEmail(email) {
      if (email) {
        return (
          emailRegexp.test(email) || this.$t('@newContractForm/emptyRequiredFieldErrorMessage')
        );
      }
      return true;
    },

    validateRequired(val) {
      const isObject = val === Object(val);
      const isFilled = isObject ? Object.keys(val).length > 0 : !!val;
      return isFilled || this.$t('@newContractForm/emptyRequiredFieldErrorMessage');
    },

    async onSubmit() {
      this.$refs.form.validate();
      this.$nextTick(async () => {
        if (!this.formValid) {
          return;
        }

        try {
          this.submitting = true;
          const { data } = await this.$http.put(
            `/api/customer/profile/${this.form.personalNumber}`,
            this.sanitizedForm,
          );
          this.form = data;
          this.error.errorMessage = '';
          this.closeModal(true);
          this.isFormDirty = false;
        } catch (e) {
          this.error = getErrorObject(e);
        } finally {
          this.submitting = false;
        }
      });
    },

    populate() {
      // deep clone customer object
      const form = JSON.parse(JSON.stringify(this.customer || {}));
      this.form = {
        ...form,
        mobilePhone: (this.customer.mobilePhone || '').replace(phonePrefixHardcode, '0'),
      };
      this.isFormDirty = false;
    },
  },

  mounted() {
    this.populate();
  },
};
</script>
